import { Box, Typography } from "@mui/material";
import CustomContainer from "../components/layout/container";

const TermsAndConditions = () => {
  return (
    <CustomContainer sx={{ marginTop: "4px", color: "rgba(84,77,160,1)", fontSize: "15px" }}>
      <Typography variant="h4" sx={{ fontWeight: "bold", marginTop: "4px", color: "rgba(84,77,160,1)", fontSize: "15px" }}>
        Service Terms & Conditions
      </Typography>
      <Typography>
        These Service Terms and Conditions (&apos;Term&apos;) govern your access
        to and use of our website and services (&apos;Services&apos;). Please
        read these Terms carefully before using our Services. By accessing or
        using our Services, you agree to be bound by these Terms. If you do not
        agree to these Terms, you may not access or use our Services. We reserve the right to modify these Terms at any time. If we make
        changes to these Terms, we will provide notice of such changes, such as
        by sending a notification, posting a notice on our website, or updating
        the &apos;Last Updated&apos; date above. Your continued use of our
        Services after we have provided notice of such changes will constitute
        your acceptance of the modified Terms.
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: "bold", marginTop: "4px", color: "rgba(84,77,160,1)", fontSize: "15px" }}>
        Privacy Policy
      </Typography>
      <Typography>
        We respect the privacy of our users. This Privacy Policy explains how we
        collect, use, and share information about you when you use our Services.
        We may collect information about you when you use our Services, such as
        your name, email address, and IP address. We use this information to
        provide, maintain, and improve our Services, and to communicate with
        you.
        We may share your information with third parties in order to provide,
        maintain, and improve our Services. We may also share your information
        if we are required to do so by law or if we believe it is necessary to
        protect our rights.
        We take steps to protect your information, but we cannot guarantee the
        security of your information. By using our Services, you acknowledge
        that you understand and agree to assume these risks.
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: "bold", marginTop: "4px", color: "rgba(84,77,160,1)", fontSize: "15px" }}>
        Copyright Notice
      </Typography>
     <Typography>
        All content on this website, including text, graphics, logos, images,
        and software, is the property of Manchester Economic Forecasting Ltd or
        its licensors and is protected by UK and international copyright laws.
        You may view, download, and print content from this website for your
        personal, non-commercial use, provided that you do not modify the
        content and that you retain all copyright and other proprietary notices
        contained in the content.
        You may not use any content on this website for commercial purposes
        without the express written consent of Manchester Economic Forecasting
        Ltd.
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: "bold", marginTop: "4px", color: "rgba(84,77,160,1)", fontSize: "15px" }}>
        Disclaimer
      </Typography>
      <Typography>
        Our Services are provided &apos;as is&apos; and &apos;as available&apos;
        without any warranties of any kind, either express or implied. We do not
        guarantee that our Services will be uninterrupted or error-free.
        We will not be liable for any damages of any kind arising from the use
        of our Services, including but not limited to direct, indirect,
        incidental, punitive, and consequential damages.
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: "bold", marginTop: "4px", color: "rgba(84,77,160,1)", fontSize: "15px" }}>
        Cookies Policy
      </Typography>
      <Typography>
        We use cookies on our website to improve your user experience and to
        understand how our website is being used. A cookie is a small piece of
        data that is stored on your device when you visit a website.
        We use two types of cookies: session cookies and persistent cookies.
        Session cookies are temporary and are deleted when you close your
        browser. Persistent cookies remain on your device for a set period of
        time or until you delete them.
        We use cookies for several purposes, such as remembering your
        preferences and tracking your use of our website. You can control the
        use of cookies through your browser settings.
        By using our website, you consent to the use of cookies in accordance
        with this Cookies Policy. If you do not agree with our use of cookies,
        you may disable cookies in your browser settings. However, this may
        impact your ability to use certain features of our website.
      </Typography>
    </CustomContainer>
  );
};
export default TermsAndConditions;
